import {useCallback, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {getNextThemeIcon, getNextThemeLabel, THEME_LABELS} from '../utils/theme';
import useClickOutside from '../hooks/useClickOutside';
import {UserIcon} from './icons';

export default function AccountMenu({username, onLogout, onAccountSettings, theme, onToggleTheme}) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const themeIcon = getNextThemeIcon(theme);
    const nextThemeLabel = getNextThemeLabel(theme);
    const closeMenu = useCallback(() => setOpen(false), []);
    useClickOutside(open, closeMenu, ref);

    return (
        <div className="account-menu" ref={ref}>
            <button
                className="account-menu-trigger"
                onClick={() => setOpen(o => !o)}
                aria-haspopup="true"
                aria-expanded={open}
                aria-label={username}
                title={username}
            >
                <UserIcon size={14} />
            </button>
            {open && (
                <div className="account-menu-dropdown">
                    <div className="account-menu-header">
                        <span className="account-menu-username">{username}</span>
                    </div>
                    <div className="account-menu-divider" />
                    <button
                        className="account-menu-item"
                        onClick={() => {
                            setOpen(false);
                            onAccountSettings();
                        }}
                    >
                        Account settings
                    </button>
                    <button className="account-menu-item account-menu-item--theme" onClick={onToggleTheme}>
                        <span className="account-menu-theme-icon">{themeIcon}</span>
                        <span>{THEME_LABELS[theme]}</span>
                        <span className="account-menu-theme-next">→ {nextThemeLabel}</span>
                    </button>
                    <div className="account-menu-divider" />
                    <button
                        className="account-menu-item account-menu-item--danger"
                        onClick={() => {
                            setOpen(false);
                            onLogout();
                        }}
                    >
                        Sign out
                    </button>
                </div>
            )}
        </div>
    );
}

AccountMenu.propTypes = {
    username: PropTypes.string.isRequired,
    onLogout: PropTypes.func.isRequired,
    onAccountSettings: PropTypes.func.isRequired,
    theme: PropTypes.string.isRequired,
    onToggleTheme: PropTypes.func.isRequired,
};
